var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrainFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    style: {
      backgroundColor: "#c9a7eb"
    },
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 716V336q0-41 19-71.5t58.5-50q39.5-19.5 100-29T480 176q86 0 146.5 9t99 28.5Q764 233 782 263t18 73v380q0 59-40.5 99.5T660 856l60 60v20h-70l-80-80H390l-80 80h-70v-20l60-60q-59 0-99.5-40.5T160 716Zm320-480q-120 0-173 15.5T231 296h501q-18-27-76.5-43.5T480 236ZM220 511h234V356H220v155Zm440 60H220h520-80Zm-146-60h226V356H514v155ZM335 741q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16Zm290 0q23 0 39-16t16-39q0-23-16-39t-39-16q-23 0-39 16t-16 39q0 23 16 39t39 16Zm-325 60h360q34 0 57-25t23-60V571H220v145q0 35 23 60t57 25Zm180-505h252-501 249Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/train_FILL0_wght400_GRAD0_opsz48.e3b0f95bbeea4d4b6a1950fd52235856.svg";
export { ForwardRef as ReactComponent };